export const BRAND_IMAGES = {
  mtn: 'https://cdn.alissoft.com.ng/apps-images/mtn.jpg',
  airtel: 'https://cdn.alissoft.com.ng/apps-images/airtel.jpg',
  glo: 'https://cdn.alissoft.com.ng/apps-images/glo.jpg',
  '9mobile': 'https://cdn.alissoft.com.ng/apps-images/9mobile.jpg',
  gotv: 'https://cdn.alissoft.com.ng/apps-images/gotv.jpg',
  dstv: 'https://cdn.alissoft.com.ng/apps-images/dstv.jpg',
  startimes: 'https://cdn.alissoft.com.ng/apps-images/startimes.jpg',
  waec: 'https://cdn.alissoft.com.ng/apps-images/waec.jpg',
  neco: 'https://cdn.alissoft.com.ng/apps-images/neco.jpg',
  abuja: 'https://cdn.alissoft.com.ng/apps-images/abuja.png',
  benin: 'https://cdn.alissoft.com.ng/apps-images/benin.jpg',
  enugu: 'https://cdn.alissoft.com.ng/apps-images/enugu.png',
  ibadan: 'https://cdn.alissoft.com.ng/apps-images/ibadan.jpg',
  portharcourt: 'https://cdn.alissoft.com.ng/apps-images/portharcourt.jpg',
  yola: 'https://cdn.alissoft.com.ng/apps-images/yola.jpg',
  ikeja: 'https://cdn.alissoft.com.ng/apps-images/ikeja.png',
  jos: 'https://cdn.alissoft.com.ng/apps-images/jos.jpg',
  kaduna: 'https://cdn.alissoft.com.ng/apps-images/kaduna.jpg',
  kano: 'https://cdn.alissoft.com.ng/apps-images/kano.png',
  smile: 'https://cdn.alissoft.com.ng/apps-images/smile.jpg',
  kirani: 'https://cdn.alissoft.com.ng/apps-images/kirani.png',
  alpha: 'https://cdn.alissoft.com.ng/apps-images/alpha.jpg',
  ratel: 'https://cdn.alissoft.com.ng/apps-images/ratel.jpeg',
};
